import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CryptoService } from './crypto.service';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteDocumentsService {

  constructor(
    private http: HttpClient,
    public cryptoService: CryptoService,
    public cookieService: CookieService
  ) { }

  public addSiteDocuments(obj): Observable<any> {
    const jsonDataMultipartName = 'addFilesToSite';
    const fileMultipartName = 'siteFiles';

    const body = {
      siteId: obj.siteId,
    };

    // multipart/form-data, append each part
    const formData = new FormData();
    formData.append(jsonDataMultipartName, new Blob([JSON.stringify(body)], { type: 'application/json' }));

    obj.filesArray.forEach((file: File) => {
      formData.append(fileMultipartName, file, file.name);
    });

    return this.http.post(environment.apiUrl + 'api/ext-site/add-files', formData)
      .pipe(map(this.handleData))
      .pipe(catchError((error) => {
        if (error.error && error.error.status === 400 && error.error.errorKey === 'Infected') {
          throw new Error('Infected');
        } else if (error.error && error.error.status === 400 && error.error.errorKey === 'EmbeddedScript') {
          throw new Error('EmbeddedScript');
        }
        return this.handleError(error);
      }));
  }

  public deleteSiteDocument(id) {
    return this.http.delete(environment.apiUrl + 'api/ext-file/' + id)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

  public showFile(folder, fileName): void {
    const uri = folder + '/' + fileName;
    this.http.get(uri, { responseType: 'blob' })
      .subscribe(response => {
        const fileURL = URL.createObjectURL(response);
        if (response.type.startsWith('image')
          || response.type.endsWith('pdf')) {
          window.open(fileURL, '_blank');
        } else {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = fileURL;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(fileURL);
        }
      });
  }
}
